import { UsuarioContext } from './contexts/UsuarioContext';
import { AppRouter } from './routers/AppRouter';
import { useState, useEffect } from 'react';
import { useSessionStore } from './hooks/useSessionStore';
import { IpDirecctionContext } from './contexts/IpDirecctionContext';
import CookieConsent, { Cookies, getCookieConsentValue } from 'react-cookie-consent'
import { Navigate } from 'react-router-dom';
import { BotonFlotante } from './components/BotonFlotante/BotonFlotante';
import { BotonCafeRural } from './components/cafeRural/botonCafeRural';
import axios from 'axios';
/**
 * The App function returns a UsuarioContext.Provider component that wraps an AppRouter component. 
 * 
 * The UsuarioContext.Provider component has a value prop that is set to an array containing the
 * MenuLateral state variable and the setMenuLateral function. 
 * 
 * The AppRouter component has an onClick prop that is set to an arrow function. 
 * 
 * The arrow function has a conditional statement that checks if the MenuLateral state variable is
 * true. If it is, the setMenuLateral function is called with a false argument. 
 * 
 * The AppRouter component is wrapped in the UsuarioContext.Provider component. 
 * 
 * The UsuarioContext.Provider component is returned by the App function.
 */

export const App = () => {

  /* A hook that allows you to use state in a functional component. */

  const [MenuLateral, setMenuLateral] = useState(false)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }

  const [consentCookie, setConsentCookie] = useState(getCookieConsentValue('appCookieConsent'))
  

  const aceptarCookie = () => {
    Cookies.set('appCookieConsent',true)
  }

  const unCafeRuralCookie = () => {
    Cookies.set('appCookieConsent',true)
  }

  useEffect(() => {
      axios({
        method: 'get',
        url: window.ipdirection + 'localidadAll/',
      }).then((response) => {
        let listaAxu = [];
        /* Mapping the response data and pushing it into an array. */
        response.data.forEach((localidad) => {
          listaAxu.push({
            id: localidad.id,
            nombre: localidad.nombre,
            provincia: localidad.provincia,
            codigoPostal: localidad.codigoPostal,
          });
        });
        localStorage.setItem("localidades", JSON.stringify(listaAxu));
      })
        .catch(error => console.log(error));
}, []);
  

  ///////////// DIRECCIÓN PARA CONECTAR CON EL BACKEND /////////////
  // window.ipdirection = "http://localhost:8000/"
  // window.ipdirection = "http://54.246.39.152:8000/"
  window.ipdirection = "https://backend.cuidatia.org:8000/"
  /////////////////////////////////////////////////////////////////

  // window.stripe_promise = 'pk_test_51N3va6F96aQvC3ShCaxsTT9YeVVqHC6F8H9b4VBI8gSVFu6lHWjz2pR2SEQZOysSSfPvC5Xo5qlmqjYoqLbCYteh00ewNgZZuI'
  // window.STRIPE_PUBLISHABLE_KEY = 'pk_live_51N3va6F96aQvC3ShoBshOe343cgBwdAZFqiWkV7VqPLi6bgrMakhYyzmWKtlBNjXIckt6kXvYeQxuppv1n0MziPE006UvSDGX3'
  

  return (
    <>
    <div id='fondo-consent-cookies' style={{display: !consentCookie ? 'block': 'None', background: 'rgba(0,0,0,.20)', position: 'fixed', zIndex: '1500', width: '100vw', height: '100vh', top: '0', left: '0'}}>
    </div>
      <CookieConsent
        style={{backgroundColor: '#282828', zIndex:'10010'}}
        buttonStyle={{color:'#fff', backgroundColor: '#23a87e'}}
        buttonText='Acepto'
        cookieName='appCookieConsent'
        onAccept={()=>{
          setConsentCookie(getCookieConsentValue('appCookieConsent'))
        }}
        expires={1}
      >
        Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Alguna de estas cookies son necesarias sin las cuales la plataforma no podría funcionar. Puede obtener más información <a href='/politica-cookies' onClick={aceptarCookie}>aquí</a>.
      </CookieConsent>

      {/* el value son la informacion o funciones que se comparte con toda la aplicacion */}
      <UsuarioContext.Provider value={[MenuLateral, setMenuLateral, closeMenu]}>
        <AppRouter />
      </UsuarioContext.Provider>

      {/* <BotonCafeRural/> */}
      {/*<BotonFlotante/>*/}
    </>
  );
}
